
import { useSelector } from 'react-redux';
import { CartInStore } from '../../slices/cart/types';
import { OrderInStore } from '../../slices/orders/types';

export const OrderSummaryDataSources = {
  CART: 'cart',
  ORDER: 'order',
} as const;

interface RootState {
  cart: CartInStore;
  order: OrderInStore;
}

const useOrderDataSource = (source: string): CartInStore | OrderInStore | null => {
  const orderSummarysource = useSelector((state: RootState) => {
    if (source === OrderSummaryDataSources.CART) {
      return state.cart;
    }
    if (source === OrderSummaryDataSources.ORDER) {
      return state.order;
    }
    return null;
  });
  return orderSummarysource;
};

export default useOrderDataSource;
